import React from "react";
import classNames from "classnames";
import "./Input.scss";
import PictureDrop from "../PictureDrop/PictureDrop";
import InputWrapper from "./InputWrapper";
import ColorInput from "./ColorInput";

const Input = ({
                   name,
                   label,
                   type = "text",
                   required = true,
                   value,
                   error,
                   className,
                   checked,
                   readOnly = false,
                   formik,
                   description,
                   onChange
               }) => {

    const fieldError = error || (formik?.touched[name] && formik?.errors[name]);

    const inputProps = {
        id: name,
        name,
        type,
        className: classNames({"wrong-input": fieldError}),
        value: value || (type === "number" ? null : ""),
        checked,
        readOnly,
        description,
        min: 0
    };

    const handleChange = (e) => {
        if (onChange) {
            onChange(e);
        }

        if (formik) {
            formik.handleChange(e);
        }
    }

    return (
        <InputWrapper className={className}>
            <label htmlFor={name} className={classNames({"required": required})}>
                {label}
            </label>

            {type === "picture" ? (
                <PictureDrop formik={formik} name={name}/>
            ) : type === "color" ? (
                <div className="input-wrapper">
                    <ColorInput
                        formik={formik}
                        name={name}
                        value={value}
                        onChange={onChange}
                        error={fieldError}
                        readOnly={readOnly}
                    />
                    {description && <p className="description">{description}</p>}
                    {fieldError && <p>{fieldError}</p>}
                </div>
            ) : (
                <div className="input-wrapper">
                    <input
                        {...inputProps}
                        value={formik ? (formik.values?.[name] ?? "") : inputProps.value}
                        onChange={handleChange}
                        onBlur={formik && formik.handleBlur}
                    />
                    {description && <p className="description">{description}</p>}
                    {fieldError && <p>{fieldError}</p>}
                </div>
            )}
        </InputWrapper>
    );
}

export default Input;